import React from "react";

const defaultContextValue = null;

const AppContext = React.createContext<any>(defaultContextValue);

export default AppContext;
